import Conf from '../../configuration'
import Storage from '../helpers/storage'

let DB = {}

export default {

    init() {

        const lang = Storage.getItem('lang') || 'en'

        const request = indexedDB.open(Conf.indexedDb.name, Conf.indexedDb.version)

        request.onupgradeneeded = function() {

            DB = request.result

            const store = DB.createObjectStore(Conf.indexedDb.name, {keyPath: 'id'})
            store.add({
                id: 'lang',
                lang: lang
            })
        }

        request.onsuccess = function() {
            DB = request.result
        }

    },


    saveLang (lang) {

        const language = lang || Storage.getItem('lang') || 'en'

        if(DB.transaction) {

            const store = DB.transaction([Conf.indexedDb.name], 'readwrite').objectStore(Conf.indexedDb.name)

            store.put({
                id: 'lang',
                lang: language
            })

        }
    }
}
